<template>
    <div class="offset-md-8 col-md-4 col-12 p-3">
        <button id="submit-button4"
                type="submit"
                @click="bookNow"
                data-style="expand-right"
                :disabled="isDisabledBtn"
                :class="{disabled: isDisabledBtn}"
                class="btn btn-red btn-sm btn-block ladda-button">
                        <span v-if="!loading" class="ladda-label">
                            {{ bookingButtonLabel }}
                        </span>
                        <b-spinner v-if="loading" label="Spinning" class="align-middle"></b-spinner>
            <span class="ladda-spinner"></span>
        </button>
    </div>
</template>
<script>

import {mapFields} from "vuex-map-fields";

export default {
  name: 'booking-btn',
  props: {},
  data() {
    return {
      terms: false,
      legal: false,
      comment: '',
      invoice_number: null,
    };
  },
  mounted() {
    this.bookingButtonLabel = this.trans.get('checkout.book_now');
  },
  methods: {
    bookNow() {
      this.loading = true;
      this.$emit('book-now');
    }
  },
  computed: {
    ...mapFields([
      'loading',
      'bookingButtonLabel'
    ]),
    isDisabledBtn() {
      if (this.loading) {
        return true;
      }
      let disabled = false;
      this.$parent.$children.map(function (component) {
        if (!component.isValid) {
          disabled = true;
        }
      });
      return disabled;
    },
    isValid() {
      return true;
    },
  }
}
</script>
